import { type RnbCalculatorPayload } from 'typings'
import { toAPIOriginalValues, toAPIPromotionBase } from '..'
import { CampaignEffect, CampaignPromotion } from '../../../../typings/campaign'
import {
  REGULAR_INCOMPATIBLE_FIELDS,
  toAPIRegularEffect,
  toAPIRegularRestrictions,
} from './regular'

export function toAPIAudiences(
  config: CampaignEffect
): Pick<RnbCalculatorPayload, 'campaigns'> {
  return {
    campaigns: config.audiences ?? [],
  }
}

export function toAPICampaignEffect(
  config: CampaignEffect
): ReturnType<typeof toAPIRegularEffect> {
  return {
    ...toAPIRegularEffect(config),
    ...toAPIAudiences(config),
  }
}

export function toAPICampaign(
  data: CampaignPromotion,
  originalValues?: RnbCalculatorPayload
) {
  return {
    ...toAPIOriginalValues(originalValues, REGULAR_INCOMPATIBLE_FIELDS),
    ...toAPIPromotionBase(data),
    ...toAPIRegularRestrictions(data.restrictions),
    ...toAPICampaignEffect(data.campaign),
  }
}
